import { Colors } from '@oy/uicore';
import { Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import { useTranslate } from 'src/hooks';
import styles from './EnvSwitcher.module.css';
import { useEnvSwitcherImpl } from './useEnvSwitcherImpl';

const EnvSwitcher = () => {
  const { getTranslation } = useTranslate();
  const { onClick, state } = useEnvSwitcherImpl();
  const { buttonLabel, isProdEnv } = state;

  return (
    <span
      role="button"
      id="environment"
      onClick={onClick}
      className={classNames(styles.envButton, {
        [styles.staging]: !isProdEnv,
      })}
    >
      {isProdEnv ? (
        <img
          width={18}
          height={18}
          alt="Switch Environment"
          src="/icons/system/wand.svg"
        />
      ) : (
        <SystemIcon name="back" size={12} color={Colors.BLACK100} />
      )}
      <Text
        textStyle={Text.Style.BodySmSemibold}
        color={isProdEnv ? Colors.WHITE : Colors.BLACK100}
      >
        {getTranslation(buttonLabel)}
      </Text>
    </span>
  );
};

export default EnvSwitcher;
